import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import { GroupDto, ResponseDto, QueryParamsDto } from "@mimber/schema"
import { groupsKeys } from "../groups.utils"

/**
 * Organization-specific hook for fetching groups
 * Can only be used in mimber-organization app
 * The organization context is automatically handled by ServerContext
 */
export const useGroups = (
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<GroupDto[]>, Error>
): UseQueryResult<ResponseDto<GroupDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useGroups")

  const { server } = useServerContext()

  return useQuery({
    queryKey: groupsKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<GroupDto[]>>(
        buildQueryString("groups", params)
      )
      return response.data
    },
    staleTime: 5 * 60 * 1000, // Consider groups data fresh for 5 minutes
    ...options,
  })
}
